export default __webpack_public_path__ + "static/media/bg-800.21c51320.jpeg";